/**
 * @file The Overlay service
 * @author Heino Lenting
 */
import { EventEmitter } from '@angular/core';
import { AsyncSubject } from 'rxjs';
import { ConfigurationsService } from '../configurations.service';
import { UserService } from '../user.service';
/**
 * Class for the overlay service
 */
var OverlayService = /** @class */ (function () {
    /**
     * Constructs a Overlay Service
     */
    function OverlayService(configurationsService, userService) {
        this.userService = userService;
        this.actions = {};
        this.open = false;
        this.params = null;
        /**
         * Is fired when the overlay is closed
         */
        this.onClosed = new EventEmitter();
        this.registerActions(configurationsService.configurations.app.actions);
    }
    /**
     * Is called to determine whether or not a link is defined to show the entity in the overlay.
     * @param {Entity} entity The entity to show.
     * @param {string} [entityType] The short name of the entitiy.
     * @returns {boolean} True when link existed.
     */
    OverlayService.prototype.entityWithOverlay = function (entity, entityType) {
        var key = entityType;
        if (!key) {
            if (!entity) {
                return false;
            }
            key = entity.entityType.shortName;
        }
        if (this.actions[key] && this.userService.isActionAllowed(this.actions[key])) {
            return true;
        }
        return false;
    };
    /**
     * Display and open the entity in the overlay.
     * @param {Entity} entity The entity to shown
     * @param {string} [entityType] The short name of the entity
     * @returns {boolean} True when the entity is shown.
     */
    OverlayService.prototype.goToEntity = function (entity, entityType) {
        var key = entityType;
        if (!key) {
            if (!entity) {
                return false;
            }
            key = entity.entityType.shortName;
        }
        var action = this.actions[key];
        if (!action) {
            return false;
        }
        this.createOverlay({
            action: action,
            entity: entity
        });
        return true;
    };
    /**
     * Is called to register the action for displaying entities in the overlay.
     * @param {ActionConfiguration[]} actions Array with actions
     * @returns void
     */
    OverlayService.prototype.registerActions = function (actions) {
        var _this = this;
        if (!actions) {
            return;
        }
        actions.forEach(function (action) {
            if (action.entity && !_this.actions[action.entity]) {
                _this.actions[action.entity] = action;
            }
        });
    };
    /**
     * Create an overlay
     * @param params The params for the overlay
     * @returns The Observable is returned
     */
    OverlayService.prototype.createOverlay = function (params) {
        // Close previous overlay
        if (this.open) {
            this.closeOverlay();
        }
        if (!params.action.configuration) {
            throw Error('Overlay is missing configuration.');
        }
        /* cross-browser solution */
        var currentScrollTop = (document.body.scrollTop) ? document.body.scrollTop : document.documentElement.scrollTop;
        if (currentScrollTop > 15) {
            document.body.scrollTop = document.documentElement.scrollTop = 1;
        }
        // Save the params
        this.params = params !== undefined ? params : null;
        // (Re)sets the overlay result value
        this.result = new AsyncSubject();
        this.params.configuration = params.action.configuration;
        this.open = true;
        return this.result;
    };
    /**
     * Closes the overlay
     * @param {any} [value=null] The parameter is passed to the onClosed event
     */
    OverlayService.prototype.closeOverlay = function (value) {
        if (value === void 0) { value = null; }
        this.open = false;
        this.params = null;
        this.onClosed.emit(value);
        if (value != null) {
            this.result.next(value);
            this.result.complete();
        }
    };
    /**
     * Is there an overlay in the service
     * @returns Returns if a overlay exists
     */
    OverlayService.prototype.isOpen = function () {
        return this.open;
    };
    /**
     * Get access to the params of the overlay
     * @returns The params
     */
    OverlayService.prototype.getParams = function () {
        return this.params;
    };
    return OverlayService;
}());
export { OverlayService };
